export const getTypesForCode = (types, code) => {
    if (types.length === 0)
        throw new Error('Cannot get types for code when no types are provided.');
    const nonMatches = [];
    const fullMatches = [];
    const partialMatches = [];
    types.forEach(option => {
        if (!option.codeFormat)
            return nonMatches.push(option);
        const { partialFormat, fullFormat } = option.codeFormat;
        if (new RegExp(fullFormat).test(code))
            return fullMatches.push(option);
        if (new RegExp(partialFormat).test(code))
            return partialMatches.push(option);
        nonMatches.push(option);
    });
    const sortedFullMatches = fullMatches.sort((a, b) => {
        return b.codeFormat.prefixLength - a.codeFormat.prefixLength;
    });
    const sortedPartialMatches = partialMatches.sort((a, b) => {
        return b.codeFormat.prefixLength - a.codeFormat.prefixLength;
    });
    const detectedType = getDetectedType(sortedFullMatches, sortedPartialMatches);
    return {
        sortedTypes: [...sortedFullMatches, ...sortedPartialMatches, ...nonMatches],
        detectedTypeId: detectedType ? detectedType.id : undefined
    };
};
const getDetectedType = (fullMatches, partialMatches) => {
    if (fullMatches.length > 0)
        return fullMatches[0];
    if (partialMatches.length > 0)
        return partialMatches[0];
    return undefined;
};
